/* eslint-disable no-console */
/* eslint-disable no-use-before-define */
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './styles.module.css';
import MobileContext from 'context/MobileContext';
// New Import

import LogoutButton from '../Button/LogoutButton';
// import ReferFriendButton from '../Button/ReferFriendButton';
import Menu from '../Menu';
import Footer from '../Footer';
import Advertisement from '../Advertsiement';
import Spinner from 'components/shared/Spinner';
import ReferralOverview from '../ReferralOverview';

const MainContent = ({
  getMvpTraningData,
  mvpTrainingData,
  profileDetails,
  logout,
  resetState,
  buddyReferralDetails,
  loadBuddyReferralDetails,
}) => {
  const isMobile = useContext(MobileContext);
  const history = useHistory();

  //LOAD PAGE
  const [isLoading, setisLoading] = useState(false);


  useEffect(() => {
    if (
      (profileDetails !== null || undefined) &&
      Object.keys(mvpTrainingData).length !== 0
    ) {
      setisLoading(true);
    }
  }, [profileDetails, mvpTrainingData]);

  // LOAD MVP TRAINING
  useEffect(() => {
    if (
      profileDetails !== undefined &&
      Object.keys(mvpTrainingData).length === 0
    ) {
      getMvpTraningData();
    }
    // eslint-disable-next-line
  }, [profileDetails]);

  const handleMangeClick = () => {
    history.push('/membership-form');
  };

  const handleSetPasswordClick = () => {
    history.push('/set-password');
  };

  return (
    <>
      {!isLoading ? (
        <Spinner />
      ) : (
        <>
          <div className={styles.cardWrapper}>
            <div className={styles.card}>
              <img
                alt=""
                className={styles.profileImage}
                src={profileDetails?.photo}
              ></img>
              <p className={styles.name}>{profileDetails?.name}</p>
              <p className={styles.email}>{profileDetails?.email}</p>
              <p className={styles.email}>
                {profileDetails?.phone || profileDetails?.mobilephone}
              </p>
              <p className={styles.setNewPassword} onClick={handleSetPasswordClick}>
                Set New Password
              </p>
              <hr className={styles.profileDivider} />
              <div className={styles.innerContainer}>
                <p className={styles.membership}>MEMBERSHIP</p>
                <button className={styles.manageButton} onClick={handleMangeClick}>
                  MANAGE
                </button>
              </div>
              <div className={styles.type}>
                <p className={styles.membershipType}>{profileDetails?.membershipTypeC}</p>
              </div>
            </div>
          </div>

          <div className={styles.menuWrapper}>
            <Menu profileDetails={profileDetails} />
          </div>

          <div className={isMobile ? styles.divider : null}></div>
          <div className={styles.advertisementWrapper}>
            <Advertisement mvpTrainingData={mvpTrainingData} />
          </div>
          <div className={styles.referWrapper}>
            {/* <ReferFriendButton name={'Refer a Friend'} /> */}
            <ReferralOverview
              loadBuddyReferralDetails={loadBuddyReferralDetails}
              buddyReferralDetails={buddyReferralDetails}
            />
          </div>

          <div className={styles.logoutWrapper}>
            <LogoutButton logout={logout} resetState={resetState} name={'Log Out'} />
          </div>

          <div className={styles.downloadAppWrapper}>
            <Footer />
          </div>
        </>
      )}
    </>
  );
};

export default MainContent;
